import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import './OrderOptions.scss'

@observer
class OrderOptions extends Component {
  state = {
    showmsg: false,
  }

  serviceOptions = [
    {
      icon: 'н',
      title: 'Оплата банковской картой',
      value: '2',
    },
    {
      icon: 'р',
      title: 'Безналичная оплата',
      value: '1',
    },
    {
      icon: 'z',
      title: 'POS-терминал',
      value: '15',
    },
    {
      icon: 'u',
      title: 'Пустой багажник',
      value: '11',
    },
    {
      icon: 'r',
      title: 'Перевозка животного',
      value: '34',
    },
    {
      icon: 'p',
      title: 'Кондиционер',
      value: '3',
    },
    {
      icon: 't',
      title: 'Некурящий водитель',
      value: '35',
    },
  ]

  setOption = id => {
    const currentValues = [...this.props.additionalServices]
    if(id !== '1'){
      if(currentValues.includes(id)){
        const elemPosition = currentValues.indexOf(id);
        currentValues.splice(elemPosition, 1);
      } else {
        currentValues.push(id)
      }
      this.props.setAdditionServices(currentValues)
      this.props.getRouteAndPrice()
    } else {
      this.setState({
        showmsg: true,
      })
    }    
  }

  closeMsg = () => {
    this.setState({
      showmsg: false,
    })
  }

  render() {
    const optionsRender = this.serviceOptions.map( item => {
      const classes = this.props.additionalServices.includes(item.value) ? 'services-item active' : 'services-item'
      return (
        <li className={classes} onClick={() => this.setOption(item.value)} key={item.value}>
          <i className="services-item__icon icons">{item.icon}</i>
          <label className="services-item__label">{item.title}</label>
        </li>
      )
    })
    return (
      <div>
        <div>
					<ul className="services-list">
						{optionsRender}
					</ul>
				</div>
        {this.state.showmsg ? (<div className="infoMsg">
          В данном регионе услуга пока не доступна.<br />
          <button onClick={this.closeMsg} className="btn btn-another-pass">OK</button>
        </div>) : null}
      </div>
    )
  }
}

const withData = inject(stores => ({ 
  setAdditionServices: stores.OrderStore.setAdditionServices,
  additionalServices: stores.OrderStore.additionalServices,
  getRouteAndPrice: stores.OrderStore.getRouteAndPrice,
}))

export default withData(OrderOptions);